<script lang="ts">
/*
User Select UI- for selecting who the current user selected is, or adding a new user
*/
import { UserDB } from '@/ts/DexieDB';
import StaticVars from '@/ts/StaticVars';
import { toRawType } from '@vue/shared';
import { defineComponent, nextTick } from 'vue'
import Button from './Button.vue';
export default defineComponent({
    async mounted() {
    },
    props: {
        users: { type: Array<UserDB>, required: true },
        UserSelected:{ type: Function, required: true },//for it to let the parent know a user was selected
        user_current: { type: UserDB, required: true },
        ShowModal:{ type:Function, default:()=>{console.log("it didn't pass ShowModal correctly");}},//have to give it a default value, or typescript thinks it could be undefined...
        AddUser:{ type: Function, required: true },
        SwitchScreen: { type: Function, default: () => { console.log("it didn't pass func correctly"); } },
    },
    data() {
        return {
        // icon:{ type:String, default:"home"},
        force_vue_to_refresh:0, //hack to make vue refresh - doesn't refresh if values changed, props changed, things updated, but will if a key is changed
        closed:true,
        };
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: {
        
    },
    methods: {
        GetUsersNotCurrent()
        {            
            let users_except = new Array<UserDB>();
            for (let i = 0; i < this.users.length; i++) {
                const user = this.users[i];
                if(user.id!=this.user_current.id)
                    users_except.push(user);                
            }
            console.log("getting users not selected, this user:", this.user_current, "users except them: ", users_except);
            return users_except;
        },
        UserSelectedInternal(user:any)
        {
            // let user_db = new UserDB(user);
            // console.log("user selected: ", user_db);
            this.UserSelected(user);
            this.closed=!this.closed;
        },
        ShowModalInternal()
        {
            // format from appvue: ShowModal(text:string, callback_yes?:Function, callback_no?:Function, text_input:boolean=false)
            this.ShowModal({text:"Add New User: Enter new username: ", callback_yes: this.UserAdded, text_input:true});
        },
        UserAdded(username:string)
        {
            console.log("Adding User, and Selecting them", username);
            this.AddUser(username);
            this.closed=!this.closed;
        },
        EditUser(user:any)
        {
            console.log("edit user called!", user);
            this.SwitchScreen(StaticVars.SCREENS.USER_EDIT, {user: user});
        }

    },
    watch : 
    {
        user_current:function(user_current) 
        {
            // this.user_current=user_current;
            console.log("watch user_current called", this.user_current);
            this.force_vue_to_refresh++;
        },  
    },
    components: { Button }
});
</script>

<template>
    <div class="wrapper" :key="force_vue_to_refresh">
        <Button :text="user_current.name" icon="person" class="icon_w_txt" fontsize="16px" :callback="()=>{closed=!closed}" 
            :hold_for_callback="true"
            :hold_callback="()=>{EditUser(user_current)}"
            />

        
            <Button v-if="!closed" v-for=" user in GetUsersNotCurrent()" :text="user.name" :callback="UserSelectedInternal" :extra_info="user" fontsize="16px"
            
            :hold_for_callback="true"
            :hold_callback="()=>{EditUser(user)}"
            />
            
            <Button v-if="!closed" type="add" fontsize="44px" :callback="()=>{ShowModalInternal()}" />
        
    </div>
</template>

<style scoped>
.wrapper
{
    position: absolute;
    top:0;
    right: 20px;
    display: flex;
    flex-direction: column;
    gap:10px;
    z-index:2;
}
.wrapper >*
{
    margin:0;
    aspect-ratio: 1;
}
</style>